import React, {useState} from "react";
import {connect} from "react-redux";
import 'moment/locale/ru';


import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import isEmpty from "lodash/isEmpty";

import {postRequestDjango, patchRequestDjango} from "../../../requests";
import {sendMessage} from "../../../thunks/Chats";
import cx from "classnames";

import { VoiceRecorder } from 'capacitor-voice-recorder';

import {
    IonFooter,
    IonTextarea,
    IonButton,
    IonModal,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonLoading
} from '@ionic/react';
import {b64toBlob, getPhoto, getPhotoFromGallery} from "../../../Components/utils";
import {Toast} from '@capacitor/toast';
import AddLocationModal from "./modals/AddLocationModal";
import SendContactsModal from "./modals/SendContactsModal";
import {AudioWrapper, AudioClock} from "../../../Components/AudioWrapper";
import {
    audioRecordingPermissionInProgress,
    setAudioRecordingPermission,
    setMicrophoneIsAvailable,
    setPermissionInitiallyAsked
} from "../../../actions/Plugins";
import get from "lodash/get";

const microphoneIcon = <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_162_12451)">
        <path
            d="M13.3563 14.825C15.1304 14.825 16.5518 13.3928 16.5518 11.6187L16.5625 5.2062C16.5625 3.43208 15.1304 1.99995 13.3563 1.99995C11.5821 1.99995 10.15 3.43208 10.15 5.2062V11.6187C10.15 13.3928 11.5821 14.825 13.3563 14.825ZM19.0206 11.6187C19.0206 14.825 16.306 17.0693 13.3563 17.0693C10.4065 17.0693 7.69187 14.825 7.69187 11.6187H5.875C5.875 15.2631 8.782 18.277 12.2875 18.8007V22.3062H14.425V18.8007C17.9305 18.2877 20.8375 15.2738 20.8375 11.6187H19.0206Z"
            fill="white"/>
    </g>
    <defs>
        <clipPath id="clip0_162_12451">
            <rect width="25.65" height="25.65" fill="white" transform="translate(0.674988 0.175003)"/>
        </clipPath>
    </defs>
</svg>;

const bigPhoneIcon = <svg width="30" height="40" viewBox="0 0 30 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M15.1944 25.3729C18.5737 25.3729 21.2812 22.6451 21.2812 19.2658L21.3015 7.05148C21.3015 3.67219 18.5737 0.944336 15.1944 0.944336C11.8151 0.944336 9.08723 3.67219 9.08723 7.05148V19.2658C9.08723 22.6451 11.8151 25.3729 15.1944 25.3729ZM26.4837 19.2658C26.2075 19.2658 25.9849 19.4903 25.972 19.7662C25.6985 25.6052 20.6582 29.6479 15.1944 29.6479C9.73055 29.6479 4.69026 25.6052 4.41676 19.7662C4.40384 19.4903 4.18123 19.2658 3.90509 19.2658H1.44437C1.16823 19.2658 0.943374 19.4903 0.953989 19.7663C1.20669 26.3352 6.40793 31.7319 12.7333 32.8755C12.977 32.9196 13.1587 33.129 13.1587 33.3766V39.1229C13.1587 39.399 13.3825 39.6229 13.6587 39.6229H16.7301C17.0062 39.6229 17.2301 39.399 17.2301 39.1229V33.3779C17.2301 33.1297 17.4126 32.92 17.6569 32.8766C23.9821 31.7509 29.1828 26.3539 29.4348 19.7663C29.4454 19.4903 29.2205 19.2658 28.9444 19.2658H26.4837Z"
        fill="white"/>
</svg>

const sendIcon = <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.51 18L21.5 9L0.51 0L0.5 7L15.5 9L0.5 11L0.51 18Z" fill="white"/>
</svg>;


const tagFacesIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z"
        fill="#9DA3A7"/>
</svg>

const attachFileIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_162_12443)">
        <path
            d="M11.253 4.81802L19.3848 12.9497C20.9475 14.5125 20.9475 17.0439 19.3848 18.6066C17.8221 20.1693 15.2906 20.1693 13.7279 18.6066L4.88909 9.76777C3.91328 8.79196 3.91328 7.20804 4.88909 6.23223C5.86489 5.25643 7.44881 5.25643 8.42462 6.23223L15.8492 13.6569C16.2382 14.0458 16.2382 14.6822 15.8492 15.0711C15.4603 15.46 14.8239 15.46 14.435 15.0711L7.71751 8.35355L6.65685 9.41421L13.3744 16.1317C14.3502 17.1075 15.9341 17.1075 16.9099 16.1317C17.8857 15.1559 17.8857 13.572 16.9099 12.5962L9.48528 5.17157C7.92258 3.60887 5.39113 3.60887 3.82843 5.17157C2.26572 6.73428 2.26572 9.26572 3.82843 10.8284L12.6673 19.6673C14.8169 21.8169 18.2958 21.8169 20.4454 19.6673C22.595 17.5177 22.595 14.0387 20.4454 11.8891L12.3137 3.75736L11.253 4.81802Z"
            fill="#9DA3A7"/>
    </g>
    <defs>
        <clipPath id="clip0_162_12443">
            <rect width="24" height="24" fill="white"/>
        </clipPath>
    </defs>
</svg>;

const photoCameraIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M12.2 15.4C13.9673 15.4 15.4 13.9673 15.4 12.2C15.4 10.4327 13.9673 9 12.2 9C10.4327 9 9 10.4327 9 12.2C9 13.9673 10.4327 15.4 12.2 15.4Z"
        fill="#9DA3A7"/>
    <path
        d="M9 2L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H16.83L15 2H9ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z"
        fill="#9DA3A7"/>
</svg>;
const trashIcon = <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1.21429 19.5556C1.21429 20.9 2.30714 22 3.64286 22H13.3571C14.6929 22 15.7857 20.9 15.7857 19.5556V4.88889H1.21429V19.5556ZM17 1.22222H12.75L11.5357 0H5.46429L4.25 1.22222H0V3.66667H17V1.22222Z"
        fill="#9DA3A7"/>
</svg>


const SendForm = (
    {
        activeChat,
        wsConnected,

        sendMessage,
        microphoneAvailable,
        microphonePermissionInitiallyAsked,
        microphoneHasPermission,
        microphonePermissionInProgress,


        setMicrophoneIsAvailable,
        setPermissionInitiallyAsked,
        setAudioRecordingPermission,
        audioRecordingPermissionInProgress,
    }
) => {
    const {t, i18n} = useTranslation();

    const [fileModalOpen, setFileModalOpen] = useState(false);
    const [fileUploaded, setFileUploaded] = useState(undefined);

    const [record, setRecord] = useState(false);
    const [editingRecord, setEditingRecord] = useState(false);

    const [isImage, setIsImage] = useState(false);

    const [uploadAsVideo, setUploadAsVideo] = useState(undefined);
    const [isVideo, setIsVideo] = useState(false);


    const [isAudio, setIsAudio] = useState(false);

    const [firstAudioPermRequest, setFirstAudioPermRequest] = useState(true);

    const [messageTextareaValue, setMessageTextareaValue] = useState('');
    const [fileInput, setFileInput] = useState(undefined);
    const [audioFileInput, setAudioFileInput] = useState(undefined);

    const [actionModal, setActionModal] = useState(false);

    const [locationModalOpen, setLocationModalOpen] = useState(false);
    const [contactsModalOpen, setContactsModalOpen] = useState(false);

    const [ionloading, setIonloading] = useState(false);

    const onMessageTextareaKeyPress = (event) => {
        if (!isEmpty(activeChat) && event.charCode === 13 && !event.shiftKey) {
            event.preventDefault();
            event.stopPropagation();

            sendTextMessage();
        }
    };

    const processModalMessage = (data) => {
        console.log(data);
        if (data) {
            sendMessage(
                activeChat.id,
                data.type,
                data.data
            )
        }
    }

    const clearFileInfo = () => {
        setIsAudio(false);
        setIsVideo(false);
        setUploadAsVideo(false);
        setIsImage(false);
    }

    const onMessageTextareaSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        sendTextMessage();
    };

    const sendTextMessage = () => {
        const trimValue = String(messageTextareaValue).trim();
        if (isEmpty(activeChat) || (!trimValue && !fileUploaded)) {
            return;
        }

        setMessageTextareaValue('');

        if (!isAudio) {
            sendMessage(
                activeChat.id,
                'text',
                {
                    text: trimValue,
                },
            )
        } else {
            setIonloading(true);
            const type = isAudio && 'voice' || 'file';
            const fileType = 'file';
            const toSend = {
                text: '',
            };
            toSend[`${fileType}_url`] = fileUploaded;

            sendMessage(
                activeChat.id,
                type,
                toSend,
            )
            setIsAudio(false);
            setEditingRecord(false);
            setFileUploaded('');
            setTimeout(() => {
                setIonloading(false);
            }, 2500);
        }


    };
    const failedToUpload = () => {
        toast.error(t('messages.new_message.toast.error.failed_to_upload', 'System failed to upload file'));
        toggleFileModal(false);
    }


    const setIsRecording = (data) => {
        setRecord(data)
        setEditingRecord(false);
    }
    const onRecordFinished = (recordedBlob) => {

        console.log('finished')
        setEditingRecord(true);
        setFileUploaded(undefined);
        let filename = new Date().getTime() + '.mp3';
        let formData = new FormData();
        formData.append("file", recordedBlob, filename);
        formData.append("encodeTo", "oga");
        toggleFileModal();
        setIonloading(true);
        postRequestDjango(`/cdn/upload/${filename}/`, formData, {timeout: 30000}).then(
            ({data}) => {
                setIonloading(false);
                if (!data.error) {
                    setIsAudio(true);
                    setFileUploaded(data.result.cdn_filepath);
                } else {
                    failedToUpload();
                    setEditingRecord(false)
                }
            },
            () => {
                setIonloading(false);
                failedToUpload();
                setEditingRecord(false)
            },
        );
    }

    const toggleFileModal = (explicitlySet = -1) => {

        if (fileModalOpen || explicitlySet === false) {
            if (fileInput) {
                fileInput.value = null;
            }
            //do stuff after hideout animation
            setTimeout(() => {
                clearFileInfo();
            }, 1000)
        }

        setFileModalOpen(explicitlySet !== -1 && typeof explicitlySet !== 'object' ? explicitlySet : !fileModalOpen);
    };

    const getPhotoAndSendIt = async (fromGallery = false) => {
        let result = fromGallery ? await getPhotoFromGallery() : await getPhoto();
        if (result) {
            setIonloading(true);
            let filename = new Date().getTime() + '.jpg';
            let formData = new FormData();
            formData.append("file", result, filename);


            postRequestDjango(`/cdn/upload/${filename}/`, formData, {timeout: 30000}).then(
                ({data}) => {
                    setIonloading(false);
                    if (!data.error) {
                        const fileType = 'image';
                        const toSend = {
                            text: '',
                        };
                        toSend[`${fileType}_url`] = data.result.cdn_filepath;
                        sendMessage(
                            activeChat.id,
                            fileType,
                            toSend,
                        )
                    } else {
                        failedToUpload();
                    }
                },
                () => {
                    setIonloading(false);
                    failedToUpload();
                },
            );

        }
    }


    const checkMicrophone = async () => {

        if (microphoneAvailable === undefined) {
            try {
                let result = await VoiceRecorder.canDeviceVoiceRecord()
                setMicrophoneIsAvailable(result.value)
                return !!result.value
            } catch (e) {
                setMicrophoneIsAvailable(false)
                return false
            }
        } else {
            return microphoneAvailable
        }
    }

    const checkMicrophonePermission = async () => {
        if (microphoneHasPermission === undefined) {
            try {
                let result = await VoiceRecorder.hasAudioRecordingPermission()
                setAudioRecordingPermission(result.value)
                return !!result.value
            } catch (e) {
                setAudioRecordingPermission(false)
                return false
            }
        } else {
            return microphoneHasPermission
        }
    }

    const requestPermission = async () => {
        setIsRecording && setIsRecording(false)
        if (!microphonePermissionInProgress) {
            try {
                audioRecordingPermissionInProgress(true);
                let result = await VoiceRecorder.requestAudioRecordingPermission()
                setAudioRecordingPermission(result.value)
                audioRecordingPermissionInProgress(false);
                return !!result.value
            } catch (e) {
                audioRecordingPermissionInProgress(false);
                setAudioRecordingPermission(false)
                return false
            }
        } else {
            return false
        }
    }

    const checkPermissions = async () => {
        //смотрим, может ли устройство записывать
        const canRecord = await checkMicrophone();
        //если да - смотрим на разрешения
        if (canRecord) {
            const hasPermission = await checkMicrophonePermission();
            //если его нет,  и первоначально мы не спршивали разрешение, спрашиваем первое разрешение
            //если его нет, и первоначально мы спрашивали - ничего не делаем. Спрашиваем только при щелчке на кнопку
            if (!hasPermission) {
                const result = await requestPermission();
                setFirstAudioPermRequest(false);
                //чтобы не нарушать логику пользователей - мы не начинаем запись мийрофона сразу после его запроса
                return false;
            } else {
                return hasPermission;
            }
        }
        return false
    }


    const startRecording = async () => {
        console.log(1)
        if (!record) {
            console.log(2)
            const permission = await checkPermissions(false)
            if (permission === true) {
                setRecord(true)
                try {
                    console.log(3)
                    VoiceRecorder.startRecording()
                } catch (e) {
                    setRecord(false)
                }
            } else {
                if (!firstAudioPermRequest) {
                    await Toast.show({
                        text: t('', 'Microphone is not available')
                    });
                }
            }
        }
    }

    const stopRecording = () => {
        if (record) {
            setRecord(false)
            VoiceRecorder.stopRecording()
              .then((result) => {
                  if (result?.value?.recordDataBase64) {
                      const dataToReturn = b64toBlob(result.value.recordDataBase64, result.value.mimeType);
                      onRecordFinished(dataToReturn);
                  }
              }, err => {
                  console.log(err)
              })
        }
    }


    const onFileModalChange = (event) => {

        const file = event.target.files[0];
        const isImage = file.type.match('image.*');
        const isVideo = file.type.match('video.*');
        const isAudio = file.type.match('audio.*');

        if (isImage && ['image/png', 'image/jpeg', 'image/gif'].indexOf(file.type) === -1) {
            Toast.show({
                text: t('messages.new_message.toast.error.choose_image', 'Select PNG, JPEG or GIF image')
            });

            return;
        }

        if (isVideo && ['video/mp4', 'image/3gpp'].indexOf(file.type) === -1) {
            Toast.show({
                text: t('messages.new_message.toast.error.choose_video', 'Choose video with MP4 or GP format')
            });

            return;
        }

        if (isAudio && ['audio/ogg', 'audio/mpeg'].indexOf(file.type) === -1) {
            Toast.show({
                text: t('messages.new_message.toast.error.choose_audio', 'Choose audio with MP3 or OGG/OGA format')
            });

            return;
        }

        setIonloading(true);
        let formData = new FormData();
        formData.append('file', file);

        postRequestDjango(`/cdn/upload/${file.name}/`, formData, {timeout: 30000}).then(
            ({data}) => {
                if (!data.error) {


                    const type = isImage && 'image' || uploadAsVideo && 'video' || isAudio && 'voice' || 'file';
                    const fileType = isImage && 'image' || uploadAsVideo && 'video' || 'file';
                    const toSend = {
                        text: fileType === 'file' ? data.result.cdn_filepath.replace(/^.*[\/\\]/ig, '') : '',
                    };
                    toSend[`${fileType}_url`] = data.result.cdn_filepath;

                    sendMessage(
                        activeChat.id,
                        type,
                        toSend,
                    )

                } else {
                    failedToUpload();
                }
                setIonloading(false);
            },
            () => {
                failedToUpload();
                setIonloading(false);
            },
        );
    };

    return <IonFooter mode="ios"
                      className={cx('i-chats-dialogue-footer', {'is-recording': !!record}, {'is-editing-recording': !!editingRecord || !!record})}>

        <input
            id="fileInput"
            type="file"
            ref={(ref) => setFileInput(ref)}
            style={{display: 'none'}}
            onChange={onFileModalChange}
            // accept="image/png, image/jpeg, image/gif"
        />
        <input
            id="fileInput"
            type="file"
            ref={(ref) => setAudioFileInput(ref)}
            style={{display: 'none'}}
            onChange={onFileModalChange}
            accept="audio/ogg, audio/mpeg"
        />
        <form onSubmit={onMessageTextareaSubmit} className="i-chats-dialogue-footer-message">
            {!(editingRecord || record) && <div className="i-chats-dialogue-footer-wrapper">
                {/*<div className="i-chats-dialogue-footer-tagFaces">*/}
                {/*    {tagFacesIcon}*/}
                {/*</div>*/}
                <IonTextarea
                    mode="ios"
                    placeholder={t('messages.new_message.placeholder_text1', "Type a message")}
                    required
                    spellcheck
                    rows={1}
                    autoGrow={messageTextareaValue !== ''}
                    disabled={isEmpty(activeChat)}
                    onIonChange={(event) => setMessageTextareaValue(event.target.value)}
                    value={messageTextareaValue}
                    onKeyPress={onMessageTextareaKeyPress}
                />
                <div className="i-chats-dialogue-footer-attachFile"
                     onClick={() => setActionModal(true)}
                     disabled={isEmpty(activeChat)}
                >
                    {attachFileIcon}
                </div>
                {!messageTextareaValue &&
                <div className="i-chats-dialogue-footer-photoCamera" onClick={() => getPhotoAndSendIt()}>
                    {photoCameraIcon}
                </div>}
            </div>}
            {(editingRecord || record) && <div className="i-chats-dialogue-footer-audio">
                <>
                    <div className="i-chats-dialogue-footer-trashCan" onClick={() => {
                        setEditingRecord(false);
                        setFileUploaded('');
                        setIsAudio(false);
                    }}>
                        {trashIcon}
                    </div>
                    {fileUploaded ? <AudioWrapper srcAudio={fileUploaded} controls></AudioWrapper> :
                        <div   className="i-chats-dialogue-footer-audio-time"><AudioClock/></div>}
                </>
            </div>}
            <IonButton
                onClick
                className="i-chats-dialogue-footer-microphone"
                type="button"
                disabled={isEmpty(activeChat)}
                onMouseDown={() => {
                    if (messageTextareaValue) {
                        return;
                    } else if (!fileUploaded) {
                        startRecording()
                    }
                }}
                onTouchStart={() => {
                    if (messageTextareaValue) {
                        return;
                    } else if (!fileUploaded) {
                        startRecording()
                    }
                }}
                onTouchEnd={() => {
                    if (fileUploaded) {
                        setIsAudio(true);
                        sendTextMessage();
                        return;
                    }

                    if (messageTextareaValue) {
                        sendTextMessage();
                    } else if (!fileUploaded) {
                        stopRecording()
                    }
                }}
                onMouseUp={() => {
                    if (fileUploaded) {
                        setIsAudio(true);
                        sendTextMessage();
                        return;
                    }

                    if (messageTextareaValue) {
                        sendTextMessage();
                    } else if (!fileUploaded) {
                        stopRecording()
                    }
                }}

                onContextMenu={(e) => {
                    e.preventDefault()
                }}
            >
                {!messageTextareaValue && !editingRecord ? record ? bigPhoneIcon : microphoneIcon : sendIcon}
            </IonButton>
        </form>

        <IonModal
            className="i-chats-dialogue-footer-actionModal"
            isOpen={actionModal}
            onDidDismiss={() => setActionModal(false)}
        >
            <IonContent className="i-chats-dialogue-footer-actionModal-content" forceOverscroll={false}>
                <IonGrid>
                    <IonRow>
                        <IonCol size="4" className="i-chats-dialogue-footer-actionModal-col">
                            <div className="i-chats-dialogue-footer-actionModal-center">
                                <IonButton className="i-chats-dialogue-footer-actionModal-btn purple"
                                           onClick={() => {
                                               fileInput.click();
                                               setActionModal(false);
                                           }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                        <path fill="#F5F5F5"
                                              d="M0 64C0 28.65 28.65 0 64 0H224V128C224 145.7 238.3 160 256 160H384V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64zM256 128V0L384 128H256z"/>
                                    </svg>
                                </IonButton>
                            </div>
                            <div
                                className="i-chats-dialogue-footer-actionModal-title">{t('messages.new_message.document', "Document")}</div>
                        </IonCol>
                        <IonCol size="4" className="i-chats-dialogue-footer-actionModal-col">
                            <div className="i-chats-dialogue-footer-actionModal-center">
                                <IonButton className="i-chats-dialogue-footer-actionModal-btn red"
                                           onClick={() => {
                                               getPhotoAndSendIt();
                                               setActionModal(false);
                                           }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path fill="#F5F5F5"
                                              d="M194.6 32H317.4C338.1 32 356.4 45.22 362.9 64.82L373.3 96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H138.7L149.1 64.82C155.6 45.22 173.9 32 194.6 32H194.6zM256 384C309 384 352 341 352 288C352 234.1 309 192 256 192C202.1 192 160 234.1 160 288C160 341 202.1 384 256 384z"/>
                                    </svg>
                                </IonButton>
                            </div>
                            <div
                                className="i-chats-dialogue-footer-actionModal-title">{t('messages.new_message.сamera', "Camera")}</div>
                        </IonCol>
                        <IonCol size="4" className="i-chats-dialogue-footer-actionModal-col">
                            <div className="i-chats-dialogue-footer-actionModal-center">
                                <IonButton className="i-chats-dialogue-footer-actionModal-btn pink"
                                           onClick={() => {
                                               getPhotoAndSendIt(true);
                                               setActionModal(false);
                                           }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path fill="#F5F5F5"
                                              d="M447.1 32h-384C28.64 32-.0091 60.65-.0091 96v320c0 35.35 28.65 64 63.1 64h384c35.35 0 64-28.65 64-64V96C511.1 60.65 483.3 32 447.1 32zM111.1 96c26.51 0 48 21.49 48 48S138.5 192 111.1 192s-48-21.49-48-48S85.48 96 111.1 96zM446.1 407.6C443.3 412.8 437.9 416 432 416H82.01c-6.021 0-11.53-3.379-14.26-8.75c-2.73-5.367-2.215-11.81 1.334-16.68l70-96C142.1 290.4 146.9 288 152 288s9.916 2.441 12.93 6.574l32.46 44.51l93.3-139.1C293.7 194.7 298.7 192 304 192s10.35 2.672 13.31 7.125l128 192C448.6 396 448.9 402.3 446.1 407.6z"/>
                                    </svg>
                                </IonButton>
                            </div>
                            <div
                                className="i-chats-dialogue-footer-actionModal-title">{t('messages.new_message.gallery', "Gallery")}</div>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size="4" className="i-chats-dialogue-footer-actionModal-col">
                            <div className="i-chats-dialogue-footer-actionModal-center">
                                <IonButton className="i-chats-dialogue-footer-actionModal-btn orange"
                                           onClick={() => {
                                               setActionModal(false);
                                               audioFileInput.click();
                                           }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path fill="#F5F5F5"
                                              d="M512 287.9l-.0042 112C511.1 444.1 476.1 480 432 480c-26.47 0-48-21.56-48-48.06V304.1C384 277.6 405.5 256 432 256c10.83 0 20.91 2.723 30.3 6.678C449.7 159.1 362.1 80.13 256 80.13S62.29 159.1 49.7 262.7C59.09 258.7 69.17 256 80 256C106.5 256 128 277.6 128 304.1v127.9C128 458.4 106.5 480 80 480c-44.11 0-79.1-35.88-79.1-80.06L0 288c0-141.2 114.8-256 256-256c140.9 0 255.6 114.5 255.1 255.3C511.1 287.5 511.1 287.7 512 287.9z"/>
                                    </svg>
                                </IonButton>
                            </div>
                            <div
                                className="i-chats-dialogue-footer-actionModal-title">{t('messages.new_message.audio', "Audio")}</div>
                        </IonCol>
                        <IonCol size="4" className="i-chats-dialogue-footer-actionModal-col">
                            <div className="i-chats-dialogue-footer-actionModal-center">
                                <IonButton className="i-chats-dialogue-footer-actionModal-btn green" onClick={() => {
                                    setActionModal(false);
                                    setTimeout(() => {
                                        setLocationModalOpen(true);
                                    }, 400)

                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                        <path fill="#F5F5F5"
                                              d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"/>
                                    </svg>
                                </IonButton>
                            </div>
                            <div
                                className="i-chats-dialogue-footer-actionModal-title">{t('messages.new_message.place', "Place")}</div>
                        </IonCol>
                        <IonCol size="4" className="i-chats-dialogue-footer-actionModal-col">
                            <div className="i-chats-dialogue-footer-actionModal-center">
                                <IonButton className="i-chats-dialogue-footer-actionModal-btn blue" onClick={() => {
                                    setActionModal(false);
                                    setTimeout(() => {
                                        setContactsModalOpen(true);
                                    }, 400)

                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                        <path fill="#F5F5F5"
                                              d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"/>
                                    </svg>


                                </IonButton>
                            </div>
                            <div
                                className="i-chats-dialogue-footer-actionModal-title">{t('messages.new_message.сontact', "Contact")}</div>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonModal>
        <AddLocationModal
            isOpen={locationModalOpen}
            onClose={(data) => {
                setLocationModalOpen(false);
                if (data) {
                    processModalMessage(data);
                }
            }}
        />
        <SendContactsModal
            isOpen={contactsModalOpen}
            onClose={(data) => {
                setContactsModalOpen(false);
                if (data) {
                    processModalMessage(data);
                }
            }}
        />

        <IonLoading
            mode="ios"
            isOpen={ionloading}
            message={'Please wait...'}
        />
    </IonFooter>;

}


const mapStateToProps = state => ({
    activeChat: state.Chats.activeChat,
    wsConnected: state.Chats.wsConnected,
    microphoneAvailable: state.Plugins.microphoneAvailable,
    microphonePermissionInitiallyAsked: state.Plugins.microphonePermissionInitiallyAsked,
    microphoneHasPermission: state.Plugins.microphoneHasPermission,
    microphonePermissionInProgress: state.Plugins.microphonePermissionInProgress,
});

const mapDispatchToProps = dispatch => ({
    sendMessage: (chat_id, contentType, payload, callback) => dispatch(sendMessage(chat_id, contentType, payload, callback)),
    setMicrophoneIsAvailable: (data) => dispatch(setMicrophoneIsAvailable(data)),
    setPermissionInitiallyAsked: (data) => dispatch(setPermissionInitiallyAsked(data)),
    setAudioRecordingPermission: (data) => dispatch(setAudioRecordingPermission(data)),
    audioRecordingPermissionInProgress: (data) => dispatch(audioRecordingPermissionInProgress(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SendForm);
